// extracted by mini-css-extract-plugin
export default {"footerContainer":"QuizFooter_footerContainer__EuEcH","activeFooterContainer":"QuizFooter_activeFooterContainer__ifKNG"};